import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/race-time-predictor-calculator',
  component: () => import('../../routes/RaceTimePredictorCalculator.svelte'),
  card: {
    id: 'race-time-predictor-calculator',
    title: 'Race Time Predictor',
    description:
      'Predict equivalent race times at any distance using the Riegel formula (k=1.06). Includes a Cameron-formula comparison and a full distance-vs-time prediction table.',
    icon: 'directions_run',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/race-time-predictor-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Race Time Predictor Calculator – Riegel Formula Equivalent Times',
    description:
      'Free race time predictor: estimate equivalent times at any distance using Riegel (k=1.06) and Cameron (k=0.974) formulas. Includes 1 mi, 5K, 10K, half, marathon, 50K, 50 mi, 100K, 100 mi. Plan your next race with confidence.',
  },
};

export default meta;